// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.admin_dashboard__53U1P {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 35px 35px;
  border-radius: 0px;
  min-height: auto !important;
  background-color: #f5f6fa;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.admin_dashboardContain__5\\+h-M {
  width: calc(100% - 320px);
  background-color: #f5f6fa;
  border-radius: 8px;
}

.admin_bodythemedark__kkcYa .admin_dashboardContain__5\\+h-M,
.admin_bodythemedark__kkcYa .admin_dashboard__53U1P,
.admin_bodythemedark__kkcYa .admin_cont2__lRIFe {
  background-color: #0f1824;
}

.admin_top_header__Ha5D6 .admin_top_header_inner__Wj5Te {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.admin_cont2__lRIFe {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #f5f6fa;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.admin_subLink__9\\+NTo svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.admin_footer__b3mra {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.admin_bodythemelight__teN3X {
  background-color: #fff;
  padding-top: 90px;
}

.admin_bodythemedark__kkcYa {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.admin_headerthemelight__UX7gn {
  background-color: #fff;
}

.admin_headerthemedark__Yum9l {
  background-color: #132337;
}

.admin_top_header__Ha5D6 {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.admin_menuthemelight__2LaLx {
  background-color: #fff;
}

.admin_menuthemedark__D4yiu {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.admin_menulinklight__voT2F span {
  color: #666666 !important;
}

.admin_menulinklight__voT2F a {
  color: #cbcbcb !important;
}

.admin_menulinklight__voT2F:hover span,
.admin_menulinklight__voT2F:hover a {
  color: #fff !important;
}

.admin_menulinkdarkSelected__0tk\\+s {
  background-color: #1c2e45;
  color: #3b82f6;
}

.admin_menuthemelight__2LaLx .admin_menulinklightSelected__emLyF {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #0f4d0f;
}

.admin_menuthemelight__2LaLx .admin_menulinklightSelected__emLyF svg path {
  color: #fff !important;
  fill: #fff;
  stroke: #fff;
}

.admin_menulinkdark__su1Y2 {
  color: #92afd3 !important;
}

.admin_menulinklight__voT2F:hover {
  color: #fff !important;
  background-color: #0f4d0f;
}

.admin_menulinklight__voT2F:hover svg path {
  color: #fff !important;
  fill: #fff;
  stroke: #fff;
}

.admin_menulinklight__voT2F .admin_sub_arrow__uXD6c svg path {
  stroke: #cbcbcb !important;
}

.admin_menulinklight__voT2F:hover .admin_sub_arrow__uXD6c svg path {
  stroke: #fff !important;
}

.admin_menulinkdark__su1Y2 .admin_sub_arrow__uXD6c svg path {
  stroke: #92afd3 !important;
}

.admin_menulinkdark__su1Y2:hover .admin_sub_arrow__uXD6c svg path {
  stroke: #fff !important;
}

.admin_menulinkdark__su1Y2:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.admin_headinglight__3N3\\+O {
  color: #60677e;
}

.admin_headingdark__-ICF6 {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.admin_searchboxlight__O-iid {
  background-color: #fff;
  border: none;
}

.admin_searchboxdark__3puUo {
  background-color: #132337;
  color: #fff;
  border: none;
}

.admin_searchboxdark__3puUo::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.admin_tableheadlight__pwspP {
  background-color: #131f43;
  border-radius: 5px 5px 0px 0px;
}

.admin_tableheadlight__pwspP th {
  color: #fff;
  background-color: #0f4d0f;
}

thead .admin_tableheadlight__pwspP th:first-child,
thead .admin_tableheaddark__wOpua th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .admin_tableheadlight__pwspP th:last-child,
thead .admin_tableheaddark__wOpua th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.admin_table__2BgBR.admin_table-borderless__PYeGi {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.admin_tableheaddark__wOpua {
  background-color: #132337;
  color: #fff;
}

.admin_table-borderless__PYeGi tr:nth-child(even) {
  background-color: #f9fafb;
}

.admin_table-borderless__PYeGi .admin_left-section__UnkZr {
  padding-top: 10px;
}

.admin_tablebodylight__s2ucq td,
.admin_tablebodydark__1LY0e td {
  padding: 0.5rem 1rem !important;
  line-height: 30px;
}

.admin_tablebodylight__s2ucq {
  background-color: #fff;
}
.admin_tablebodylight__s2ucq:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.admin_tablebodydark__1LY0e {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.admin_tablebodydark__1LY0e:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.admin_paginationlight__k\\+Ki3 {
  color: #60677e !important;
  font-size: 13px !important;
}

.admin_paginationdark__vJL1l {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.admin_formthemelight__Zfnlx {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.admin_formthemedark__\\+IaY0 {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.admin_formthemedark__\\+IaY0 ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.admin_viewformlight__i7AsJ {
  background-color: #f3f6f9;
}

.admin_permissionboxlight__N5W1X {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.admin_permissionboxdark__ezYeU {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.admin_errormsgclr__\\+wS5F {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.admin_graphclrlight__UQ\\+iR {
  background-color: #fff;
}

.admin_graphclrdark__eTHYi {
  background-color: #132337;
}

/* 
Counter theme
*/
#admin_card1bglight__BR8yW {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#admin_card1bgdark__pq9Kn {
  background: #392f28;
}

#admin_card2bglight__yGmZ3 {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#admin_card2bgdark__y\\+ZIA {
  background: #1c3238;
}

#admin_card3bglight__Gbm43 {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#admin_card3bgdark__5nzt0 {
  background: #3a2434;
}

#admin_card4bglight__h55Jk {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#admin_card4bgdark__0kldh {
  background: #2f264f;
}

#admin_card1bgdark__pq9Kn a,
#admin_card1bgdark__pq9Kn p,
#admin_card2bgdark__y\\+ZIA a,
#admin_card2bgdark__y\\+ZIA p,
#admin_card3bgdark__5nzt0 a,
#admin_card3bgdark__5nzt0 p,
#admin_card4bgdark__0kldh a,
#admin_card4bgdark__0kldh p {
  color: #fff;
}

/* 
Action button theme
*/
.admin_actionbtnlight__V6tFX {
  color: rgba(70, 71, 91, 0.8705882353);
}

.admin_actionbtnlight__V6tFX:hover {
  cursor: pointer;
}

.admin_actionbtndark__vQN26 {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.admin_profiledropdownlight__qzQoW {
  background-color: #fff;
}

.admin_profiledropdowndark__E0IQt {
  background-color: #151521;
}

.admin_settingsection__M1TYB #admin_addform__FbCHi.admin_formthemedark__\\+IaY0 .admin_savebtn__6ejKI {
  background-color: #3b82f6;
  color: #fff;
}

#admin_addform__FbCHi.admin_formthemedark__\\+IaY0 .admin_savebtn__6ejKI {
  background-color: #3b82f6;
  color: #fff;
}

.admin_profile_conatiner__XcKwd {
  border-radius: 5px !important;
}

.admin_bodythemedark__kkcYa .admin_ag-theme-alpine__krm6t .admin_ag-row__pKwor {
  background: #000 !important;
}

.admin_bodythemedark__kkcYa .admin_formbtn__S-Pq5 {
  background-color: #3b82f6;
}

.admin_bodythemedark__kkcYa .admin_formbtn__S-Pq5:hover {
  background-color: #2563eb;
}

.admin_bodythemedark__kkcYa .admin_resetbtn__Alw0i {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.admin_bodythemedark__kkcYa .admin_resetbtn__Alw0i:hover {
  background-color: #3b82f6;
}

.admin_headingdark__-ICF6 span {
  background-color: #132337;
}

.admin_resetbtn__Alw0i {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131f43;
  color: #131f43;
  min-width: 113px;
}

.admin_resetbtn__Alw0i:hover,
.admin_resetbtn__Alw0i:active,
.admin_resetbtn__Alw0i:focus {
  background-color: #131f43;
  color: #fff;
}

.admin_addBtn__B1wYl {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38a169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.admin_addbtnlight__t1cK3 {
  background-color: #38a169;
}

.admin_addbtndark__Af10q {
  background-color: #3b82f6;
}

.admin_addbtndark__Af10q:hover {
  background-color: #2563eb;
}

.admin_formthemedark__\\+IaY0 label {
  color: #92afd3;
}

.admin_addBtn__B1wYl svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.admin_addBtn__B1wYl:hover {
  color: #fff;
  background-color: #38a169;
  border: none;
}

.admin_cust_addBtn__0Jc4g.admin_addBtn__B1wYl svg {
  top: 2px;
}

.admin_deleteBtn__BzqDC {
  min-width: 130px;
  height: 50px;
  background-color: #f94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.admin_deleteBtn__BzqDC {
  min-width: 130px;
  height: 50px;
  background-color: #f94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.admin_deleteBtn__BzqDC:active,
.admin_deleteBtn__BzqDC:focus {
  background-color: #f94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.admin_deleteBtn__BzqDC svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.admin_deleteBtn__BzqDC:hover,
.admin_deleteBtn__BzqDC:active,
.admin_deleteBtn__BzqDC:focus {
  background-color: #f94747;
  color: #fff;
  border: none;
}

.admin_confirmBtn__J\\+Blr {
  background-color: #131f43;
}

.admin_confirmBtn__J\\+Blr:hover,
.admin_confirmBtn__J\\+Blr:active,
.admin_confirmBtn__J\\+Blr:focus {
  background-color: #131f43;
}

.admin_confirmBtn__J\\+Blr svg {
  top: 0;
}

.admin_delPopContainer__K23hl .admin_modal-body__ryykP {
  padding: 25px;
  text-align: center;
}

.admin_delPopContainer__K23hl .admin_delet_icon__iMGws {
  margin-bottom: 11px;
}

.admin_delPopContainer__K23hl p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.admin_arrowback__QIOy9 svg {
  fill: #000;
}

.admin_bodythemedark__kkcYa .admin_arrowback__QIOy9 {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.admin_bodythemedark__kkcYa .admin_arrowback__QIOy9 svg {
  fill: #3b82f6;
}

.admin_bodythemedark__kkcYa .admin_drpdwn_btn__f-A0p {
  background-color: #132337;
}

.admin_bodythemedark__kkcYa .admin_empname__Cx7\\+S {
  color: #92afd3 !important;
}

.admin_bodythemedark__kkcYa .admin_navitemli__A9dIO a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.admin_bodythemedark__kkcYa .admin_tabnavli__0kunL a.admin_settingsgeneral__ykeZf,
.admin_bodythemedark__kkcYa .admin_tabnavli__0kunL a.admin_settingslinks__1AyXp:hover {
  background-color: #3b82f6;
  color: #fff;
}

.admin_bodythemedark__kkcYa .admin_tabnavli__0kunL a.admin_settingslinks__1AyXp {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.admin_headerthemedark__Yum9l .admin_dropdown_menu_contain__e4KGs {
  background-color: #1c2e45;
  color: #fff;
}

.admin_headerthemedark__Yum9l .admin_dropdown_menu_contain__e4KGs ul li a,
.admin_headerthemedark__Yum9l .admin_dropdown_menu_contain__e4KGs .admin_dropdown_item__o7tFQ,
.admin_headerthemedark__Yum9l .admin_dropdown_menu_contain__e4KGs .admin_dropdown_item__o7tFQ h5 {
  color: #fff;
}

.admin_headerthemedark__Yum9l .admin_dropdown_menu_contain__e4KGs ul li a:hover,
.admin_headerthemedark__Yum9l .admin_dropdown_menu_contain__e4KGs .admin_dropdown_item__o7tFQ:hover {
  background-color: #132337;
  color: #fff;
}

.admin_dropdown_item__o7tFQ:active {
  background-color: #f5f6fa;
}

.admin_profile_arrrow_dwn__QqOcK {
  stroke: #132337;
}

.admin_headerthemedark__Yum9l .admin_profile_arrrow_dwn__QqOcK {
  stroke: #fff;
}

.admin_dateinputbox1__wM2Ln input,
.admin_dateinputbox1__wM2Ln span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .admin_tableheadlight__pwspP th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .admin_dashboard__53U1P {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .admin_cont2__lRIFe {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (min-width: 767px) {
  .admin_messageminwidth__OAaIv {
    white-space: normal;
    word-wrap: break-word;
    width: 37%;
  }
}
@media only screen and (max-width: 767px) {
  td {
    max-width: 700px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .admin_messageminwidth__OAaIv {
    white-space: nowrap;
    word-wrap: break-word;
  }
  .admin_sectionright__KoOnV {
    float: unset !important;
  }
  .admin_dashboard__53U1P {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .admin_cont2__lRIFe {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
    overflow-x: inherit !important;
  }
  .admin_bodythemelight__teN3X,
  .admin_bodythemedark__kkcYa {
    padding-top: 83px;
  }
  .admin_top_header__Ha5D6 {
    min-height: 69px;
  }
}
@media (min-width: 576px) {
  .admin_exer_modal_contain__MtcL0 .admin_modal-dialog__2rCdw {
    max-width: 1055px;
  }
  .admin_delPopContainer__K23hl .admin_modal-dialog__2rCdw {
    max-width: 350px;
  }
}
.admin_admin__x4rlQ {
  --primary: rgb(59, 130, 246);
  --secondary: rgb(147, 51, 234);
  --text-color: rgb(100, 116, 139);
  --heading-color: rgb(30, 41, 59);
  --bg: rgb(241, 245, 249);
  color: var(--text-color);
  font-size: 14px;
  background-color: var(--bg);
  display: inline-block;
  width: 100%;
  min-height: 100dvh;
}
.admin_admin__x4rlQ[data-bs-theme=dark] {
  --bg: rgb(15, 24, 36);
  --text-color: rgb(209, 209, 209);
  --heading-color: rgb(255, 255, 255);
}
.admin_admin__x4rlQ .admin_adminContent__wkjjC {
  padding: 35px;
  margin-top: 100px;
}
@media (max-width: 767px) {
  .admin_admin__x4rlQ .admin_adminContent__wkjjC {
    padding: 10px;
  }
}
.admin_admin__x4rlQ .admin_badge__FHZEV {
  font-size: 8px;
  background-color: var(--bs-danger);
  border-radius: 100%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  position: absolute;
  right: 0;
  top: 0;
}
.admin_admin__x4rlQ .admin_dropdown__B9Y-N {
  position: absolute;
  background-color: var(--bs-body-bg);
  box-shadow: rgba(30, 34, 40, 0.06) 0px 0px 25px 0px;
  min-width: 250px;
  border-radius: 8px;
  right: 20px;
  top: 70px;
}
.admin_admin__x4rlQ .admin_notifications__3lcPh {
  max-width: 420px;
}
.admin_admin__x4rlQ .admin_notifications__3lcPh ::-webkit-scrollbar {
  width: 6px;
}
.admin_admin__x4rlQ .admin_notifications__3lcPh ::-webkit-scrollbar-track {
  background: var(--bs-border-color);
}
.admin_admin__x4rlQ .admin_notifications__3lcPh ::-webkit-scrollbar-thumb {
  background: rgba(136, 136, 136, 0.8235294118);
}
.admin_admin__x4rlQ .admin_notifications__3lcPh ::-webkit-scrollbar-thumb:hover {
  background: rgba(85, 85, 85, 0.7411764706);
}
.admin_admin__x4rlQ .admin_notifications__3lcPh .admin_header__fJLFM {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
}
.admin_admin__x4rlQ .admin_notifications__3lcPh .admin_header__fJLFM h4 {
  font-size: 16px;
  color: var(--heading-color);
  margin-bottom: 0;
}
.admin_admin__x4rlQ .admin_notifications__3lcPh .admin_list__LV9Ay {
  max-height: 350px;
  overflow-y: scroll;
  padding: 10px 0;
}
.admin_admin__x4rlQ .admin_notifications__3lcPh .admin_list__LV9Ay .admin_item__XnczR {
  display: flex;
  gap: 15px;
  padding: 10px 20px;
  cursor: pointer;
}
.admin_admin__x4rlQ .admin_notifications__3lcPh .admin_list__LV9Ay .admin_item__XnczR:hover {
  background-color: color-mix(in srgb, var(--primary) 5%, var(--bs-body-bg) 100%);
}
.admin_admin__x4rlQ .admin_notifications__3lcPh .admin_list__LV9Ay .admin_item__XnczR:nth-child(even) .admin_avatar__7uwMT {
  background-color: rgba(127, 255, 212, 0.345);
}
.admin_admin__x4rlQ .admin_notifications__3lcPh .admin_list__LV9Ay .admin_item__XnczR:nth-child(odd) .admin_avatar__7uwMT {
  background-color: rgba(234, 255, 127, 0.345);
}
.admin_admin__x4rlQ .admin_notifications__3lcPh .admin_list__LV9Ay .admin_item__XnczR .admin_avatar__7uwMT {
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 8px;
  flex-shrink: 0;
}
.admin_admin__x4rlQ .admin_notifications__3lcPh .admin_list__LV9Ay .admin_item__XnczR .admin_content__z43Ul {
  flex-grow: 1;
}
.admin_admin__x4rlQ .admin_notifications__3lcPh .admin_list__LV9Ay .admin_item__XnczR .admin_content__z43Ul h6 {
  font-size: 14px;
}
.admin_admin__x4rlQ .admin_notifications__3lcPh .admin_list__LV9Ay .admin_item__XnczR .admin_content__z43Ul p {
  display: flex;
  font-size: 12px;
  gap: 5px;
  align-items: center;
}
.admin_admin__x4rlQ .admin_notifications__3lcPh .admin_list__LV9Ay .admin_item__XnczR .admin_time__ub2oJ {
  flex-shrink: 0;
  font-size: 10px;
}
.admin_admin__x4rlQ .admin_notifications__3lcPh .admin_list__LV9Ay .admin_item__XnczR .admin_time__ub2oJ span {
  position: relative;
  display: inline-block;
}
.admin_admin__x4rlQ .admin_notifications__3lcPh .admin_list__LV9Ay .admin_item__XnczR .admin_time__ub2oJ span::before {
  content: "";
  position: absolute;
  left: -8px;
  top: 5px;
  width: 5px;
  height: 5px;
  border-radius: 100%;
  background: var(--primary);
}
.admin_admin__x4rlQ .admin_notifications__3lcPh .admin_footer__b3mra {
  display: flex;
  padding: 10px 5px;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid var(--bs-border-color);
}
.admin_admin__x4rlQ .admin_notifications__3lcPh .admin_footer__b3mra button {
  font-size: 14px;
}
.admin_admin__x4rlQ .admin_notifications__3lcPh .admin_footer__b3mra button.admin_primaryBtn__I99cc {
  background-color: var(--primary);
}
.admin_admin__x4rlQ .admin_profileBtn__gYb1\\+ {
  padding: 0;
  display: flex;
  align-items: center;
  gap: 16px;
}
.admin_admin__x4rlQ .admin_profileBtn__gYb1\\+ img {
  width: 45px;
  height: 45px;
  border-radius: 100px;
  object-fit: cover;
}
.admin_admin__x4rlQ .admin_profileBtn__gYb1\\+ h6 {
  color: var(--Font-black, #0B0D0F);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 84px;
}
@media (max-width: 767px) {
  .admin_admin__x4rlQ .admin_profileBtn__gYb1\\+ h6 {
    display: none;
  }
}
.admin_admin__x4rlQ .admin_profileMenu__HU1J2 {
  padding: 20px;
}
.admin_admin__x4rlQ .admin_profileMenu__HU1J2 .admin_header__fJLFM * {
  margin-bottom: 0;
}
.admin_admin__x4rlQ .admin_profileMenu__HU1J2 .admin_header__fJLFM > p {
  font-size: 12px;
}
.admin_admin__x4rlQ .admin_profileMenu__HU1J2 .admin_header__fJLFM .admin_avatar__7uwMT {
  width: 50px;
  height: 50px;
}
.admin_admin__x4rlQ .admin_profileMenu__HU1J2 .admin_header__fJLFM .admin_info__3iFZr {
  margin-left: 8px;
}
.admin_admin__x4rlQ .admin_profileMenu__HU1J2 .admin_header__fJLFM .admin_info__3iFZr h6 {
  margin-bottom: 4px;
  font-size: 14px;
  font-weight: 700;
}
.admin_admin__x4rlQ .admin_profileMenu__HU1J2 .admin_header__fJLFM .admin_info__3iFZr p {
  opacity: 0.8;
  font-size: 12px;
}
.admin_admin__x4rlQ .admin_profileMenu__HU1J2 ul {
  padding-top: 20px;
  font-size: 15px;
}
.admin_admin__x4rlQ .admin_profileMenu__HU1J2 ul li:last-child {
  border-top: 1px solid var(--bs-border-color);
  padding-top: 5px;
  margin-top: 5px;
}
.admin_admin__x4rlQ .admin_profileMenu__HU1J2 ul li a {
  border-radius: 8px;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-color);
}
.admin_admin__x4rlQ .admin_profileMenu__HU1J2 ul li a span {
  background-color: var(--primary);
  color: var(--bs-body-bg);
  padding: 2px 8px;
  font-size: 10px;
  border-radius: 6px;
}
.admin_admin__x4rlQ .admin_profileMenu__HU1J2 ul li a:hover {
  background-color: rgba(30, 34, 40, 0.06);
  color: var(--primary);
}

.admin_logout__iT8rt {
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}
.admin_logout__iT8rt h5 {
  font-size: 18px;
  font-weight: 700;
}

.admin_adminhead_left__Z444\\+ {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  height: 3px;
  margin-right: 10px;
}
.admin_adminhead_left__Z444\\+ h3 {
  color: var(--Neutrals-Text-Black, #1A1A1A);
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-left: 10px !important;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (max-width: 767px) {
  .admin_adminhead_left__Z444\\+ h3 {
    font-size: 18px;
    max-width: 100px;
  }
}

.admin_minimized__nA7jv .admin_dongle_menu__yi1qa {
  right: -22px !important;
  top: 27px !important;
}

.admin_cnt_outer__z0DUF {
  display: inline-block;
  padding: 20px;
  margin-bottom: 30px;
  width: 100%;
  border-radius: 20px;
  background: #FFF;
}

@media (max-width: 767px) {
  .admin_minimized__nA7jv .admin_dongle_menu__yi1qa {
    display: block !important;
    position: fixed !important;
    top: 26px !important;
    left: 4px !important;
    z-index: 166666;
    width: 36px;
  }
  body .admin_minimized__nA7jv .admin_main_page__YK4Gq {
    width: calc(100% - 0px) !important;
  }
}
.admin_minimized__nA7jv .admin_main_page__YK4Gq {
  width: calc(100% - 80px) !important;
  transition: all 300ms ease-in-out;
  top: 0;
}

.admin_minimized__nA7jv .admin_min_logo__fy-ru {
  display: block !important;
  padding: 23px 0 61px;
  max-width: 29px;
  width: 29px;
  text-align: center;
  margin: auto;
}
.admin_minimized__nA7jv .admin_min_logo__fy-ru svg {
  height: auto;
  width: 100%;
}

.admin_admin__x4rlQ .admin_min_logo__fy-ru {
  display: none;
}

.admin_minimized__nA7jv .admin_logo__BIkbA {
  display: none !important;
}

.admin_minimized__nA7jv .admin_parentmenu__gp\\+IM li a {
  padding: 20px 26px !important;
  gap: 50px !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/users/admin.module.scss"],"names":[],"mappings":"AAEA;EACE,mCAAA;ACAF;;ADGA;;EAAA;AAgDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AAQA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAvFO;EAwFP,2BAAA;EACA,gBAAA;ACrEF;;ADuEA;EACE,yBAAA;EACA,yBA7FO;EA8FP,kBAAA;ACpEF;;ADsEA;;;EAGE,yBAjEmB;ACFrB;;ADqEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;AClEF;;ADqEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBArHO;EAsHP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;AChEF;;ADsEA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACnEF;;ADsEA;EACE,YAAA;ACnEF;;ADsEA;EACE,sBA9FY;AC2Bd;;ADsEA;;CAAA;AAGA;EACE,sBArGY;EAsGZ,iBAAA;ACnEF;;ADqEA;EACE,yBApHe;EAqHf,iBAAA;AClEF;;ADqEA;;CAAA;AAGA;EACE,sBAjHY;AC+Cd;;ADqEA;EACE,yBAhIe;AC8DjB;;ADoEA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACjEF;;ADoEA;;CAAA;AAGA;EACE,sBArIY;ACoEd;;ADmEA;EACE,yBAnJe;ACmFjB;;ADmEA;;CAAA;AAGA;EACE,yBAAA;AChEF;;ADmEA;EACE,yBAAA;AChEF;;ADmEA;;EAEE,sBAAA;AChEF;;ADmEA;EACE,yBArKqB;EAsKrB,cA9KiB;AC8GnB;;ADkEA;EACE,sCAAA;EACA,sBAAA;EACA,yBAAA;AC/DF;;ADiEA;EACE,sBAAA;EACA,UAAA;EACA,YAAA;AC9DF;;ADiEA;EACE,yBAAA;AC9DF;;ADiEA;EACE,sBAAA;EACA,yBAAA;AC9DF;;ADiEA;EACE,sBAAA;EACA,UAAA;EACA,YAAA;AC9DF;;ADiEA;EACE,0BAAA;AC9DF;;ADiEA;EACE,uBAAA;AC9DF;;ADiEA;EACE,0BAAA;AC9DF;;ADiEA;EACE,uBAAA;AC9DF;;ADiEA;EACE,yBAnNqB;EAoNrB,WA3MY;AC6Id;;ADiEA;;CAAA;AAGA;EACE,cA/Me;ACiJjB;;ADiEA;EACE,cAnNe;ACqJjB;;ADiEA;;CAAA;AAGA;EACE,sBA7NY;EA8NZ,YAAA;AC9DF;;ADiEA;EACE,yBA7Oe;EA8Of,WAnOY;EAoOZ,YAAA;AC9DF;;ADgEA;EACE,cApOe;ACuKjB;;ADgEA;;CAAA;AAGA;EACE,yBAzRc;EA0Rd,8BAAA;AC7DF;;AD+DA;EACE,WAlPY;EAmPZ,yBAAA;AC5DF;;AD8DA;;EAEE,0BAAA;AC3DF;;AD6DA;;EAEE,0BAAA;AC1DF;;AD4DA;EACE,kBAAA;ACzDF;;AD2DA;EACE,kBAAA;ACxDF;;AD0DA;EACE,oCAAA;EACA,gCAAA;ACvDF;;AD0DA;EACE,yBAjQkB;EAkQlB,WA1QY;ACmNd;;ADyDA;EACE,yBAAA;ACtDF;;ADwDA;EACE,iBAAA;ACrDF;;ADuDA;;EAEE,+BAAA;EACA,iBAAA;ACpDF;;ADsDA;EACE,sBAxRY;ACqOd;ADqDE;EACE,yBAAA;EACA,YAAA;ACnDJ;;ADsDA;EACE,0CAAA;EACA,cA9Re;AC2OjB;ADqDE;EACE,yCAAA;EACA,YAAA;ACnDJ;;ADuDA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;ACpDF;;ADsDA;EACE,yBAAA;EACA,0BAAA;ACnDF;;ADsDA;;CAAA;AAGA;EACE,sBAzTY;EA0TZ,yBAAA;EACA,qDAAA;ACnDF;;ADqDA;EACE,yBAtTkB;EAuTlB,yBAAA;EACA,eAAA;AClDF;ADoDE;EACE,cAhUa;AC8QjB;;ADsDA;;CAAA;AAGA;EACE,yBA9UgB;AC2RlB;;ADsDA;EACE,yBAAA;EACA,yBAAA;ACnDF;;ADqDA;EACE,yBA7VmB;EA8VnB,yBAAA;AClDF;;ADqDA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AClDF;;ADqDA;;CAAA;AAGA;EACE,sBAjWY;AC+Sd;;ADqDA;EACE,yBA7VkB;AC2SpB;;ADqDA;;CAAA;AAGA;EACE,iGAAA;EACA,sBA7WY;AC2Td;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;EACE,gGAAA;EACA,sBAtXY;ACoUd;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;EACE,gGAAA;EACA,sBA/XY;AC6Ud;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;EACE,gGAAA;EACA,sBAxYY;ACsVd;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;;;;;;;;EAQE,WAvZY;ACqWd;;ADqDA;;CAAA;AAGA;EACE,qCAAA;AClDF;;ADoDA;EACE,eAAA;ACjDF;;ADmDA;EACE,cAjae;ACiXjB;;ADmDA;;CAAA;AAGA;EACE,sBAAA;AChDF;;ADmDA;EACE,yBAAA;AChDF;;ADmDA;EACE,yBAlciB;EAmcjB,WApbY;ACoYd;;ADkDA;EACE,yBAtciB;EAucjB,WAxbY;ACyYd;;ADkDA;EACE,6BAAA;AC/CF;;ADkDA;EACE,2BAAA;AC/CF;;ADkDA;EACE,yBAndiB;ACoanB;;ADkDA;EACE,yBAtduB;ACuazB;;ADkDA;EACE,WA5cY;EA6cZ,6BAAA;EACA,yBAAA;AC/CF;;ADkDA;EACE,yBAjeiB;ACkbnB;;ADkDA;EACE,yBAjee;ACkbjB;;ADkDA;EACE,eAAA;EACA,gBA5gBc;EA6gBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cA1gBc;EA2gBd,gBAAA;AC/CF;;ADiDA;;;EAGE,yBAhhBc;EAihBd,WAteY;ACwbd;;ADiDA;EACE,gBAAA;EACA,YAAA;EACA,WA5eY;EA6eZ,yBAtgBY;EAugBZ,YAAA;EACA,eAAA;EACA,gBAjiBc;ACmfhB;;ADiDA;EACE,yBA7gBY;AC+dd;;ADgDA;EACE,yBAtgBiB;ACydnB;;AD+CA;EACE,yBAxgBuB;AC4dzB;;AD+CA;EACE,cA9gBgB;ACkelB;;AD+CA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;AC5CF;;AD+CA;EACE,WAxgBY;EAygBZ,yBAliBY;EAmiBZ,YAAA;AC5CF;;AD+CA;EACE,QAAA;AC5CF;;AD+CA;EACE,gBAAA;EACA,YAAA;EACA,yBAtiBU;EAuiBV,WArhBY;EAshBZ,eAAA;EACA,gBAxkBc;EAykBd,YAAA;AC5CF;;AD+CA;EACE,gBAAA;EACA,YAAA;EACA,yBAhjBU;EAijBV,WA/hBY;EAgiBZ,eAAA;EACA,gBAllBc;EAmlBd,YAAA;AC5CF;;AD+CA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;AC5CF;;AD+CA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;AC5CF;;AD+CA;;;EAGE,yBAvkBU;EAwkBV,WAtjBY;EAujBZ,YAAA;AC5CF;;AD+CA;EACE,yBAtmBc;AC0jBhB;;AD+CA;;;EAGE,yBA5mBc;ACgkBhB;;AD+CA;EACE,MAAA;AC5CF;;AD+CA;EACE,aAAA;EACA,kBAAA;AC5CF;;AD+CA;EACE,mBAAA;AC5CF;;AD+CA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC5CF;;AD+CA;EACE,UAAA;AC5CF;;AD+CA;EACE,yCAzmBa;EA0mBb,cA9mBiB;ACkkBnB;;AD+CA;EACE,aAlnBiB;ACskBnB;;AD+CA;EACE,yBAhnBe;ACokBjB;;AD+CA;EACE,yBAAA;AC5CF;;AD+CA;EACE,6BAAA;EACA,yBAAA;EACA,WA/mBY;ACmkBd;;AD+CA;;EAEE,yBAnoBiB;EAooBjB,WArnBY;ACykBd;;AD8CA;EACE,6BAAA;EACA,yBAAA;EACA,WA1nBY;AC+kBd;;AD8CA;EACE,yBAvoBqB;EAwoBrB,WA/nBY;AColBd;;AD8CA;;;EAGE,WAroBY;AC0lBd;;AD8CA;;EAEE,yBArpBe;EAspBf,WA3oBY;ACgmBd;;AD8CA;EACE,yBA3rBO;ACgpBT;;AD8CA;EACE,eA9pBe;ACmnBjB;;AD8CA;EACE,YAvpBY;AC4mBd;;AD8CA;;EAEE,sBAAA;AC3CF;;AD8CA,iBAAA;AAOA;EACE;IACE,gBAAA;ECjDF;AACF;ADmDA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;ECjDF;EDmDA;IACE,2BAAA;IACA,gBAAA;ECjDF;AACF;ADmDA;EACE;;IAAA;AC/CF;ADmDA;EACE;IACE,mBAAA;IACA,qBAAA;IACA,UAAA;ECjDF;AACF;ADoDA;EACE;IACE,gBAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;EClDF;EDoDA;IACE,mBAAA;IACA,qBAAA;EClDF;EDoDA;IACE,uBAAA;EClDF;EDoDA;IACE,6BAAA;EClDF;AACF;ADoDA;EAEE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;IACA,8BAAA;ECnDF;EDqDA;;IAEE,iBAAA;ECnDF;EDqDA;IACE,gBAAA;ECnDF;AACF;ADsDA;EACE;IACE,iBAAA;ECpDF;EDsDA;IACE,gBAAA;ECpDF;AACF;AAnvBA;EACE,4BAAA;EACA,8BAAA;EACA,gCAAA;EACA,gCAAA;EACA,wBAAA;EAQA,wBAAA;EACA,eAAA;EACA,2BAAA;EAKA,qBAAA;EACA,WAAA;EACA,kBAAA;AA0uBF;AAzvBE;EACE,qBAAA;EACA,gCAAA;EACA,mCAAA;AA2vBJ;AA3aE;EACE,aAAA;EACA,iBAAA;AA6aJ;AA5aI;EAHF;IAII,aAAA;EA+aJ;AACF;AA5aE;EACE,cAAA;EACA,kCAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;AA8aJ;AA3aE;EACE,kBAAA;EACA,mCAAA;EACA,mDAAA;EACA,gBAAA;EAEA,kBAAA;EACA,WAAA;EACA,SAAA;AA4aJ;AAzaE;EACE,gBAAA;AA2aJ;AAxaI;EACE,UAAA;AA0aN;AAvaI;EACE,kCAAA;AAyaN;AAtaI;EACE,6CAAA;AAwaN;AAraI;EACE,0CAAA;AAuaN;AApaI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;AAsaN;AApaM;EACE,eAAA;EACA,2BAAA;EACA,gBAAA;AAsaR;AAlaI;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;AAoaN;AAlaM;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AAoaR;AAlaQ;EACE,+EAAA;AAoaV;AA9ZU;EACE,4CAAA;AAgaZ;AA3ZU;EACE,4CAAA;AA6ZZ;AAzZQ;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AA2ZV;AAxZQ;EACE,YAAA;AA0ZV;AAxZU;EACE,eAAA;AA0ZZ;AAvZU;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AAyZZ;AArZQ;EACE,cAAA;EACA,eAAA;AAuZV;AArZU;EACE,kBAAA;EACA,qBAAA;AAuZZ;AArZY;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,0BAAA;AAuZd;AAhZI;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,4CAAA;AAkZN;AAhZM;EACE,eAAA;AAkZR;AAhZQ;EACE,gCAAA;AAkZV;AA5YE;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AA8YJ;AA5YI;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;AA8YN;AA3YI;EACE,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AA6YN;AA5YM;EAZF;IAaI,aAAA;EA+YN;AACF;AA3YE;EACE,aAAA;AA6YJ;AA1YM;EACE,gBAAA;AA4YR;AAzYM;EACE,eAAA;AA2YR;AAxYM;EACE,WAAA;EACA,YAAA;AA0YR;AAvYM;EACE,gBAAA;AAyYR;AAvYQ;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAyYV;AAtYQ;EACE,YAAA;EACA,eAAA;AAwYV;AAnYI;EACE,iBAAA;EACA,eAAA;AAqYN;AAlYQ;EACE,4CAAA;EACA,gBAAA;EACA,eAAA;AAoYV;AAjYQ;EACE,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,wBAAA;AAmYV;AAjYU;EACE,gCAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAmYZ;AAhYU;EACE,wCAAA;EACA,qBAAA;AAkYZ;;AAzXA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AA4XF;AA1XE;EACE,eAAA;EACA,gBAAA;AA4XJ;;AAxXA;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AA2XF;AAzXE;EACE,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;AA2XJ;AA1XI;EAXF;IAYI,eAAA;IACA,gBAAA;EA6XJ;AACF;;AAxXA;EACE,uBAAA;EACA,oBAAA;AA2XF;;AAzXA;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AA4XF;;AAzXA;EACE;IACE,yBAAA;IACA,0BAAA;IACA,oBAAA;IACA,oBAAA;IACA,eAAA;IACA,WAAA;EA4XF;EAzXA;IACE,kCAAA;EA2XF;AACF;AAxXA;EACE,mCAAA;EACA,iCAAA;EACA,MAAA;AA0XF;;AArXA;EACE,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;AAwXF;AAtXE;EACE,YAAA;EACA,WAAA;AAwXJ;;AApXA;EACE,aAAA;AAuXF;;AApXA;EACE,wBAAA;AAuXF;;AApXA;EAEE,6BAAA;EACA,oBAAA;AAsXF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: 'Urbanist', sans-serif;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #f5f6fa;\n$primary-color: #131f43;\n$icon-bgcolor: #f6f6f6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #f3f4f8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #faf4fb;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #faf7f3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #f5f9fc;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #ac44bb;\n$cardIcon3-color: #d69a5f;\n$cardIcon4-color: #176ca5;\n$green-color: #38a169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading: #0b0d0f;\n$light-gray: #999999;\n$menu_icon: #cbcbcb;\n$red-color: #f94747;\n$dark-active-blue: #3b82f6;\n$dark-light-blue: #92afd3;\n$addBtn-dark-blue: #3b82f6;\n$addBtn-dark-blue-hover: #2563eb;\n$backBtn-dark: #3b82f633;\n\n$darkTheme_blue: #132337;\n$darkTheme_darkBlue: #0f1824;\n$darkTheme_selectBlue: #1c2e45;\n$darkTheme_updateBtn: #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131f43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: 35px 35px;\n  border-radius: 0px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-color: $mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: #0f4d0f;\n}\n.menuthemelight .menulinklightSelected svg path {\n  color: $white-color !important;\n  fill: #fff;\n  stroke: #fff;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: #0f4d0f;\n}\n\n.menulinklight:hover svg path {\n  color: $white-color !important;\n  fill: #fff;\n  stroke: #fff;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n  background-color: #0f4d0f;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n}\ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #f9fafb;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 30px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover {\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color: $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n}\n\n.modalStyleDark {\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (min-width: 767px) {\n  .messageminwidth {\n    white-space: normal;\n    word-wrap: break-word;\n    width: 37%;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  td {\n    max-width: 700px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  .messageminwidth {\n    white-space: nowrap;\n    word-wrap: break-word;\n  }\n  .sectionright {\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n \n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n    overflow-x: inherit !important;\n  }\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 83px;\n  }\n  .top_header {\n    min-height: 69px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n}\n","\n@import \"../../styles/Variables/Variables.scss\";\n.admin {\n  --primary: rgb(59, 130, 246);\n  --secondary: rgb(147, 51, 234);\n  --text-color: rgb(100, 116, 139);\n  --heading-color: rgb(30, 41, 59);\n  --bg: rgb(241, 245, 249);\n\n  &[data-bs-theme=\"dark\"] {\n    --bg: rgb(15, 24, 36);\n    --text-color: rgb(209, 209, 209);\n    --heading-color: rgb(255, 255, 255);\n  }\n\n  color: var(--text-color);\n  font-size: 14px;\n  background-color: var(--bg);\n  //   svg {\n  //     stroke: rgb(51, 65, 85);\n  //   }\n  // display: flex;\n  display: inline-block;\n  width: 100%;\n  min-height: 100dvh;\n\n  // &.minimized:not(.overlay) {\n  //   .mainMenu {\n  //     width: 80px;\n  //     // padding: 0 10px;\n  //     // position: relative;\n  //     float: left;\n\n  //     .parentmenu {\n  //       >ul>li {\n  //         position: relative;\n\n  //         >button {\n  //           &.submenuopen {\n  //             background-color: color-mix(in srgb,\n  //                 var(--primary) 30%,\n  //                 white 80%);\n  //             color: var(--primary);\n  //           }\n\n  //           justify-content: center;\n\n  //           >span,\n  //           >svg {\n  //             display: none !important;\n  //           }\n\n  //           i svg {\n  //             width: 26px !important;\n  //             height: 26px !important;\n  //           }\n  //         }\n  //       }\n  //     }\n\n  //     .submenu {\n  //       ::before {\n  //         content: \"\";\n  //         width: 70px;\n  //         height: 100%;\n  //         position: absolute;\n  //         left: -50px;\n  //         top: 0;\n  //       }\n\n  //       padding: 15px 15px 20px 15px;\n  //       border-radius: 7px;\n  //       box-shadow: rgba(30, 34, 40, 0.06) 0px 0px 25px 0px;\n  //       position: absolute;\n  //       left: 0px;\n  //       top: -20px;\n  //       transform: translate(80px, 20px);\n  //       min-width: 250px;\n  //       background-color: var(--bs-body-bg);\n\n  //       button {\n  //         padding: 0 !important;\n  //       }\n\n  //       .submenu {\n  //         transform: translate(calc(100% + 10px), 20px);\n  //       }\n  //     }\n\n  //     .logo {\n  //       h3 {\n  //         display: none;\n  //       }\n  //     }\n  //   }\n\n  //   .page {\n  //     header {}\n  //   }\n  // }\n\n  // &.overlay {\n  //   &.minimized {\n  //     .mainMenu {\n  //       left: -100%;\n  //     }\n\n  //     .overlay_bg {\n  //       pointer-events: none;\n  //       opacity: 0;\n  //     }\n  //   }\n\n  //   .mainMenu {\n  //     position: fixed;\n  //     z-index: 5000;\n  //     min-height: 100dvh;\n  //     left: 0;\n  //   }\n\n  //   .overlay_bg {\n  //     opacity: 1;\n  //     pointer-events: all;\n  //     cursor: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='32' height='32' fill='rgba(199,199,199,1)'%3E%3Cpath d='M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z'%3E%3C/path%3E%3C/svg%3E\"),\n  //       auto;\n  //   }\n  // }\n\n  // .overlay_bg {\n  //   background-color: rgba(0, 0, 0, 0.5);\n  //   inset: 0;\n  //   position: fixed;\n  //   backdrop-filter: blur(2px);\n  //   z-index: 4999;\n  //   opacity: 0;\n  //   pointer-events: none;\n  // }\n\n  // .mainMenu {\n  //   // width: 240px;\n  //   width: 290px;\n  //   padding: 0 0px;\n  //   transition: all 300ms ease-in-out;\n  //   background-color: #fff;\n  //   // position: relative;\n  //   float: left;\n  //   position: fixed;\n  //   height: 100vh;\n  //   z-index: 15555;\n\n  //   .parentmenu {\n  //     padding-top: 20px;\n\n  //     ul {\n  //       display: flex;\n  //       flex-direction: column;\n  //       gap: 0px;\n  //       padding: 0;\n\n  //       li {\n  //         width: 100%;\n  //         display: inline-block;\n\n  //         a {\n  //           width: 100%;\n  //           padding: 20px 50px;\n  //           color: #2A2A2A;\n  //           font-size: 16px;\n  //           font-style: normal;\n  //           font-weight: 600;\n  //           line-height: normal;\n  //           display: inline-flex;\n  //           align-items: center;\n  //           gap: 14px;\n\n  //           &:hover {\n  //             background-color: #0F4D0F;\n  //             color: var(--Neutrals-White, #FFF);\n  //             stroke: rgb(255 255 255);\n\n  //             svg {\n  //               path {\n  //                 stroke: rgb(255 255 255);\n  //                 fill: #fff;\n  //               }\n\n\n  //             }\n  //           }\n\n  //           svg {\n  //             min-width: 24px;\n  //             height: 24px;\n  //           }\n  //         }\n\n  //       }\n  //     }\n  //   }\n\n  //   .submenu {\n  //     list-style: none;\n  //     display: flex;\n  //     flex-direction: column;\n  //     gap: 10px;\n\n  //     li:first-child {\n  //       margin-top: 10px;\n  //     }\n\n  //     a,\n  //     button {\n  //       &:hover {\n  //         background-color: transparent;\n  //       }\n  //     }\n  //   }\n\n  //   button,\n  //   a {\n  //     align-items: center;\n  //     color: var(--text-color);\n\n  //     i>svg {\n  //       width: 18px;\n  //       height: 18px;\n  //     }\n\n  //     &:hover {\n\n  //       color: var(--primary);\n  //     }\n\n  //     font-size: 14px;\n\n  //     span {\n  //       display: inline-block;\n  //       margin-left: 10px;\n  //     }\n  //   }\n\n  //   .logo {\n  //     padding: 23px 50px 41px;\n  //     display: inline-block;\n  //     align-items: center;\n  //     justify-content: center;\n  //     max-width: 100%;\n  //     text-align: center;\n  //     margin: auto;\n\n  //     svg {\n  //       max-width: 184px;\n  //       height: auto;\n  //     }\n  //   }\n\n  //   nav {\n  //     // display: flex;\n  //     // flex-direction: column;\n  //     overflow-y: auto;\n  //     height: calc(100% - 120px);\n  //     padding-bottom: 57px;\n  //     overflow-x: hidden;\n  //   }\n  // }\n\n  // .main_page {\n  //   // background-color: aquamarine;\n  //   // flex: 1 0 auto;\n  //   // display: grid;\n  //   // grid-template-rows: auto 1fr auto;\n  //   width: calc(100% - 290px);\n  //   float: right;\n  //   transition: all 300ms ease-in-out;\n  //   padding-right: 35px;\n  //   @media (max-width: 767px) {\n  //     padding-right: 0px;\n  //     width: calc(100% - 0px);\n  //   }\n  //   &::after\n  //   {\n  //     position: fixed;\n  //     right: 0;\n  //     content: '';\n  //     top: 0;\n  //     bottom: 0;\n  //     width: 34px;\n  //     height: 100vh;\n  //     background: #fff;\n  //     @media (max-width: 767px) {\n  //       display: none;\n  //     }\n  //   }\n\n  //   header {\n  //     // position: sticky;\n  //     top: 0;\n  //     z-index: 1000;\n  //     padding: 25px 44px;\n  //     background-color: #fff;\n  //     width: -webkit-fill-available;\n  //     position: fixed;\n\n  //     @media (max-width: 767px) {\n  //       padding: 25px 0px 25px 44px;\n  //     }\n\n\n  //     .search {\n  //       width: 300px;\n  //       position: relative;\n  //       display: inline-block;\n\n  //       input {\n  //         border: 1px solid #eee;\n  //         outline: none;\n  //         border-radius: 4px;\n  //         padding: 8px 15px 8px 35px;\n  //         width: 100%;\n\n  //         &:focus {\n  //           border: 1px solid var(--primary);\n  //         }\n  //       }\n\n  //       &::before {\n  //         content: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='18' height='18' fill='rgba(78,78,78,0.8)'%3E%3Cpath d='M11 2C15.968 2 20 6.032 20 11C20 15.968 15.968 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2ZM11 18C14.8675 18 18 14.8675 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18ZM19.4853 18.0711L22.3137 20.8995L20.8995 22.3137L18.0711 19.4853L19.4853 18.0711Z'%3E%3C/path%3E%3C/svg%3E\");\n  //         position: absolute;\n  //         left: 8px;\n  //         top: 9px;\n  //       }\n  //     }\n  //   }\n\n  //   footer {\n  //     margin: 0;\n  //     padding: 18px 70px 11px 33px;\n  //     border-radius: 0;\n  //     background-color: var(--bs-body-bg);\n  //     width: 100%;\n  //     text-align: right;\n  //     display: block;\n  //     position: fixed;\n  //     bottom: 0;\n  //     width: -webkit-fill-available;\n  //   }\n  // }\n\n  .adminContent {\n    padding: 35px;\n    margin-top: 100px;\n    @media (max-width: 767px) {\n      padding: 10px;\n    }\n  }\n\n  .badge {\n    font-size: 8px;\n    background-color: var(--bs-danger);\n    border-radius: 100%;\n    width: 16px;\n    height: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    position: absolute;\n    right: 0;\n    top: 0;\n  }\n\n  .dropdown {\n    position: absolute;\n    background-color: var(--bs-body-bg);\n    box-shadow: rgba(30, 34, 40, 0.06) 0px 0px 25px 0px;\n    min-width: 250px;\n\n    border-radius: 8px;\n    right: 20px;\n    top: 70px;\n  }\n\n  .notifications {\n    max-width: 420px;\n\n    // max-width: 360px;\n    ::-webkit-scrollbar {\n      width: 6px;\n    }\n\n    ::-webkit-scrollbar-track {\n      background: var(--bs-border-color);\n    }\n\n    ::-webkit-scrollbar-thumb {\n      background: #888888d2;\n    }\n\n    ::-webkit-scrollbar-thumb:hover {\n      background: #555555bd;\n    }\n\n    .header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 16px;\n\n      h4 {\n        font-size: 16px;\n        color: var(--heading-color);\n        margin-bottom: 0;\n      }\n    }\n\n    .list {\n      max-height: 350px;\n      overflow-y: scroll;\n      padding: 10px 0;\n\n      .item {\n        display: flex;\n        gap: 15px;\n        padding: 10px 20px;\n        cursor: pointer;\n\n        &:hover {\n          background-color: color-mix(in srgb,\n              var(--primary) 5%,\n              var(--bs-body-bg) 100%);\n        }\n\n        &:nth-child(even) {\n          .avatar {\n            background-color: rgba(127, 255, 212, 0.345);\n          }\n        }\n\n        &:nth-child(odd) {\n          .avatar {\n            background-color: rgba(234, 255, 127, 0.345);\n          }\n        }\n\n        .avatar {\n          width: 40px;\n          height: 40px;\n          overflow: hidden;\n          border-radius: 8px;\n          flex-shrink: 0;\n        }\n\n        .content {\n          flex-grow: 1;\n\n          h6 {\n            font-size: 14px;\n          }\n\n          p {\n            display: flex;\n            font-size: 12px;\n            gap: 5px;\n            align-items: center;\n          }\n        }\n\n        .time {\n          flex-shrink: 0;\n          font-size: 10px;\n\n          span {\n            position: relative;\n            display: inline-block;\n\n            &::before {\n              content: \"\";\n              position: absolute;\n              left: -8px;\n              top: 5px;\n              width: 5px;\n              height: 5px;\n              border-radius: 100%;\n              background: var(--primary);\n            }\n          }\n        }\n      }\n    }\n\n    .footer {\n      display: flex;\n      padding: 10px 5px;\n      align-items: center;\n      justify-content: space-between;\n      border-top: 1px solid var(--bs-border-color);\n\n      button {\n        font-size: 14px;\n\n        &.primaryBtn {\n          background-color: var(--primary);\n        }\n      }\n    }\n  }\n\n  .profileBtn {\n    padding: 0;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n\n    img {\n      width: 45px;\n      height: 45px;\n      border-radius: 100px;\n      object-fit: cover;\n    }\n\n    h6 {\n      color: var(--Font-black, #0B0D0F);\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n      margin: 0;\n      overflow: hidden;\n      display: inline-block;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      width: 84px;\n      @media (max-width: 767px) {\n        display: none;\n      }\n    }\n  }\n\n  .profileMenu {\n    padding: 20px;\n\n    .header {\n      * {\n        margin-bottom: 0;\n      }\n\n      >p {\n        font-size: 12px;\n      }\n\n      .avatar {\n        width: 50px;\n        height: 50px;\n      }\n\n      .info {\n        margin-left: 8px;\n\n        h6 {\n          margin-bottom: 4px;\n          font-size: 14px;\n          font-weight: 700;\n        }\n\n        p {\n          opacity: 0.8;\n          font-size: 12px;\n        }\n      }\n    }\n\n    ul {\n      padding-top: 20px;\n      font-size: 15px;\n\n      li {\n        &:last-child {\n          border-top: 1px solid var(--bs-border-color);\n          padding-top: 5px;\n          margin-top: 5px;\n        }\n\n        a {\n          border-radius: 8px;\n          padding: 5px 10px;\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          color: var(--text-color);\n\n          span {\n            background-color: var(--primary);\n            color: var(--bs-body-bg);\n            padding: 2px 8px;\n            font-size: 10px;\n            border-radius: 6px;\n          }\n\n          &:hover {\n            background-color: rgba(30, 34, 40, 0.06);\n            color: var(--primary);\n          }\n        }\n      }\n    }\n  }\n\n}\n\n.logout {\n  padding: 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n\n  h5 {\n    font-size: 18px;\n    font-weight: 700;\n  }\n}\n\n.adminhead_left {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  height: 3px;\n  margin-right: 10px;\n\n  h3 {\n    color: var(--Neutrals-Text-Black, #1A1A1A);\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    margin-left: 10px !important;\n    overflow: hidden;\n    display: inline-block;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    @media (max-width: 767px) {\n      font-size: 18px;\n      max-width: 100px;\n    }\n\n  }\n}\n\n.minimized .dongle_menu {\n  right: -22px !important;\n  top: 27px !important;\n}\n.cnt_outer {\n  display: inline-block;\n  padding:20px;\n  margin-bottom: 30px;\n  width: 100%;\n  border-radius: 20px;\n  background: #FFF;\n  // margin-bottom: 42px;\n}\n@media (max-width: 767px) {\n  .minimized .dongle_menu {\n    display: block !important;\n    position: fixed !important;\n    top: 26px !important;\n    left: 4px !important;\n    z-index: 166666;\n    width: 36px;\n  }\n\n  body .minimized .main_page {\n    width: calc(100% - 0px) !important;\n  }\n}\n\n.minimized .main_page {\n  width: calc(100% - 80px) !important;\n  transition: all 300ms ease-in-out;\n  top: 0;\n  // height: 100vh;\n\n}\n\n.minimized .min_logo {\n  display: block !important;\n  padding: 23px 0 61px;\n  max-width: 29px;\n  width: 29px;\n  text-align: center;\n  margin: auto;\n\n  svg {\n    height: auto;\n    width: 100%;\n  }\n}\n\n.admin .min_logo {\n  display: none;\n}\n\n.minimized .logo {\n  display: none !important;\n}\n\n.minimized .parentmenu li a {\n\n  padding: 20px 26px !important;\n  gap: 50px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `admin_dashboard__53U1P`,
	"dashboardContain": `admin_dashboardContain__5+h-M`,
	"bodythemedark": `admin_bodythemedark__kkcYa`,
	"cont2": `admin_cont2__lRIFe`,
	"top_header": `admin_top_header__Ha5D6`,
	"top_header_inner": `admin_top_header_inner__Wj5Te`,
	"subLink": `admin_subLink__9+NTo`,
	"footer": `admin_footer__b3mra`,
	"bodythemelight": `admin_bodythemelight__teN3X`,
	"headerthemelight": `admin_headerthemelight__UX7gn`,
	"headerthemedark": `admin_headerthemedark__Yum9l`,
	"menuthemelight": `admin_menuthemelight__2LaLx`,
	"menuthemedark": `admin_menuthemedark__D4yiu`,
	"menulinklight": `admin_menulinklight__voT2F`,
	"menulinkdarkSelected": `admin_menulinkdarkSelected__0tk+s`,
	"menulinklightSelected": `admin_menulinklightSelected__emLyF`,
	"menulinkdark": `admin_menulinkdark__su1Y2`,
	"sub_arrow": `admin_sub_arrow__uXD6c`,
	"headinglight": `admin_headinglight__3N3+O`,
	"headingdark": `admin_headingdark__-ICF6`,
	"searchboxlight": `admin_searchboxlight__O-iid`,
	"searchboxdark": `admin_searchboxdark__3puUo`,
	"tableheadlight": `admin_tableheadlight__pwspP`,
	"tableheaddark": `admin_tableheaddark__wOpua`,
	"table": `admin_table__2BgBR`,
	"table-borderless": `admin_table-borderless__PYeGi`,
	"left-section": `admin_left-section__UnkZr`,
	"tablebodylight": `admin_tablebodylight__s2ucq`,
	"tablebodydark": `admin_tablebodydark__1LY0e`,
	"paginationlight": `admin_paginationlight__k+Ki3`,
	"paginationdark": `admin_paginationdark__vJL1l`,
	"formthemelight": `admin_formthemelight__Zfnlx`,
	"formthemedark": `admin_formthemedark__+IaY0`,
	"viewformlight": `admin_viewformlight__i7AsJ`,
	"permissionboxlight": `admin_permissionboxlight__N5W1X`,
	"permissionboxdark": `admin_permissionboxdark__ezYeU`,
	"errormsgclr": `admin_errormsgclr__+wS5F`,
	"graphclrlight": `admin_graphclrlight__UQ+iR`,
	"graphclrdark": `admin_graphclrdark__eTHYi`,
	"card1bglight": `admin_card1bglight__BR8yW`,
	"card1bgdark": `admin_card1bgdark__pq9Kn`,
	"card2bglight": `admin_card2bglight__yGmZ3`,
	"card2bgdark": `admin_card2bgdark__y+ZIA`,
	"card3bglight": `admin_card3bglight__Gbm43`,
	"card3bgdark": `admin_card3bgdark__5nzt0`,
	"card4bglight": `admin_card4bglight__h55Jk`,
	"card4bgdark": `admin_card4bgdark__0kldh`,
	"actionbtnlight": `admin_actionbtnlight__V6tFX`,
	"actionbtndark": `admin_actionbtndark__vQN26`,
	"profiledropdownlight": `admin_profiledropdownlight__qzQoW`,
	"profiledropdowndark": `admin_profiledropdowndark__E0IQt`,
	"settingsection": `admin_settingsection__M1TYB`,
	"addform": `admin_addform__FbCHi`,
	"savebtn": `admin_savebtn__6ejKI`,
	"profile_conatiner": `admin_profile_conatiner__XcKwd`,
	"ag-theme-alpine": `admin_ag-theme-alpine__krm6t`,
	"ag-row": `admin_ag-row__pKwor`,
	"formbtn": `admin_formbtn__S-Pq5`,
	"resetbtn": `admin_resetbtn__Alw0i`,
	"addBtn": `admin_addBtn__B1wYl`,
	"addbtnlight": `admin_addbtnlight__t1cK3`,
	"addbtndark": `admin_addbtndark__Af10q`,
	"cust_addBtn": `admin_cust_addBtn__0Jc4g`,
	"deleteBtn": `admin_deleteBtn__BzqDC`,
	"confirmBtn": `admin_confirmBtn__J+Blr`,
	"delPopContainer": `admin_delPopContainer__K23hl`,
	"modal-body": `admin_modal-body__ryykP`,
	"delet_icon": `admin_delet_icon__iMGws`,
	"arrowback": `admin_arrowback__QIOy9`,
	"drpdwn_btn": `admin_drpdwn_btn__f-A0p`,
	"empname": `admin_empname__Cx7+S`,
	"navitemli": `admin_navitemli__A9dIO`,
	"tabnavli": `admin_tabnavli__0kunL`,
	"settingsgeneral": `admin_settingsgeneral__ykeZf`,
	"settingslinks": `admin_settingslinks__1AyXp`,
	"dropdown_menu_contain": `admin_dropdown_menu_contain__e4KGs`,
	"dropdown_item": `admin_dropdown_item__o7tFQ`,
	"profile_arrrow_dwn": `admin_profile_arrrow_dwn__QqOcK`,
	"dateinputbox1": `admin_dateinputbox1__wM2Ln`,
	"messageminwidth": `admin_messageminwidth__OAaIv`,
	"sectionright": `admin_sectionright__KoOnV`,
	"exer_modal_contain": `admin_exer_modal_contain__MtcL0`,
	"modal-dialog": `admin_modal-dialog__2rCdw`,
	"admin": `admin_admin__x4rlQ`,
	"adminContent": `admin_adminContent__wkjjC`,
	"badge": `admin_badge__FHZEV`,
	"dropdown": `admin_dropdown__B9Y-N`,
	"notifications": `admin_notifications__3lcPh`,
	"header": `admin_header__fJLFM`,
	"list": `admin_list__LV9Ay`,
	"item": `admin_item__XnczR`,
	"avatar": `admin_avatar__7uwMT`,
	"content": `admin_content__z43Ul`,
	"time": `admin_time__ub2oJ`,
	"primaryBtn": `admin_primaryBtn__I99cc`,
	"profileBtn": `admin_profileBtn__gYb1+`,
	"profileMenu": `admin_profileMenu__HU1J2`,
	"info": `admin_info__3iFZr`,
	"logout": `admin_logout__iT8rt`,
	"adminhead_left": `admin_adminhead_left__Z444+`,
	"minimized": `admin_minimized__nA7jv`,
	"dongle_menu": `admin_dongle_menu__yi1qa`,
	"cnt_outer": `admin_cnt_outer__z0DUF`,
	"main_page": `admin_main_page__YK4Gq`,
	"min_logo": `admin_min_logo__fy-ru`,
	"logo": `admin_logo__BIkbA`,
	"parentmenu": `admin_parentmenu__gp+IM`
};
export default ___CSS_LOADER_EXPORT___;
